<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8" cy="8" r="8" fill="#DA4E4E"/>
        <path d="M7.04994 4.66477C7.02277 4.12143 7.45598 3.66602 8 3.66602C8.54402 3.66602 8.97723 4.12143 8.95006 4.66477L8.69834 9.69931C8.6806 10.0541 8.38775 10.3327 8.0325 10.3327H7.9675C7.61225 10.3327 7.3194 10.0541 7.30166 9.69931L7.04994 4.66477Z" fill="white"/>
        <path d="M8.86686 11.8324C8.86686 12.2926 8.49377 12.6657 8.03353 12.6657C7.57329 12.6657 7.2002 12.2926 7.2002 11.8324C7.2002 11.3721 7.57329 10.999 8.03353 10.999C8.49377 10.999 8.86686 11.3721 8.86686 11.8324Z" fill="white"/>
    </svg>
</template>
<script>
export default { name: 'error-icon' }
</script>
